import FileUploader from '@/components/FileUploader'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useContext } from 'react'
import { OnboardingContext } from '@/context/OnboardingContext'


const WizardStep5 = () => {
  const { logoImage, websiteDetails } = useContext(OnboardingContext)
  const onImageChanged = (imageUrl) => {
    logoImage.set(imageUrl)
  }
  const hasUploadedLogo = Boolean(logoImage?.url)
  return (
    <Box>
      <Typography variant='h5' sx={{ mb: '-6px', color: '#1A1A1A' }}>
        Upload your own
      </Typography>
      <div className={hasUploadedLogo ? 'mt-[24px]' : 'mt-[8px]'}>
        <FileUploader
          onFileAdded={onImageChanged}
          onFileRemoved={onImageChanged}
          initialImage={logoImage.url}
          selected
          name={websiteDetails.data.title}
        />
      </div>
    </Box>
  )
}

export default WizardStep5
